import React from 'react';
import { useHistory } from 'react-router-dom';

/**
 *
 * @returns {[module:url.URLSearchParams,((function(module:url.URLSearchParams): void))]}
 */
export default function useQueryParams() {
  const history = useHistory();

  return React.useMemo(() => {
    const search = new URLSearchParams(history.location.search);

    return [search, (nextSearch) => {
      history.push({
        pathname: history.location.pathname,
        search: nextSearch.toString(),
      });
    }];
  }, [history.location.search]);
}
